"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
var filters_1 = require("../immutable/filters");
var immutable_1 = require("immutable");
exports.createFilters = function (filters, updater) {
    return filters && filters.map(function (filter) { return new filters_1.Filter(filter, updater); });
};
var _a = createConnect_1.default({
    field: 'query',
    mapProps: function (query, meta, update) { return ({
        filters: meta && meta.has('filters')
            && exports.createFilters(meta.get('filters'), update)
            || immutable_1.Map()
    }); },
    handlers: {
        onClearAll: function (_a) {
            var update = _a.update;
            return function (e) {
                if (e)
                    e.preventDefault();
                update('filters');
            };
        },
    }
}), hook = _a[0], connect = _a[1];
exports.hook = hook;
exports.connect = connect;
//# sourceMappingURL=connectBreadcrumbs.js.map